import { Box, styled } from "@mui/material";

import { StyledBorderedCard } from "components/bordered-card";

export const AssistantWalkthroughFeatureCard = styled(StyledBorderedCard)(
  ({ theme }) => ({
    padding: theme.spacing(4),
    backgroundColor: theme.palette.custom.semantic.surface.card,
    display: "flex",
    flexDirection: "column",
    gap: theme.spacing(2),
    color: theme.palette.primary.main,
  })
);

export const AssistantWalkthroughFeatureActions = styled(Box)(({ theme }) => ({
  display: "flex",
  flexWrap: "wrap",
  alignItems: "center",
  gap: theme.spacing(2),
  marginTop: theme.spacing(2),
}));

export const StyledAssistantWalkthroughFeatureListBoxDisplay = styled(Box)(
  ({ theme }) => ({
    display: "flex",
    flexDirection: "column",
    gap: theme.spacing(4),
  })
);
